import React from 'react'
import { Redirect } from 'react-router-dom'
import ActivityIndicator from '../../components/ActivityIndicator'
import API from '../../services/api'
import { withTranslation as translate } from 'react-i18next'

class ProcessingPayment extends React.Component {
  constructor () {
    super()

    this.state = {
      status: undefined,
      declineReason: undefined,
      paymentInitiated: false
    }

    // Bind the makePayment method
    this.makePayment = this.makePayment.bind(this)
  }

  paymentKey (params) {
    return `payment-${params.quote_id}-${params.operator_id}`
  }

  makePayment (params) {
    const paymentKey = this.paymentKey(params)

    // Check if payment has already been initiated for this quote
    if (this.state.paymentInitiated || sessionStorage.getItem(paymentKey)) {
      return
    }

    // Mark payment as initiated in state and session storage
    sessionStorage.setItem(paymentKey, 'true')
    this.setState({ paymentInitiated: true })

    // Make the actual API call
    API.makeSignupPayment(params)
  }

  componentDidMount () {
    let { operatorUUID, quoteUUID, paymentMethod } = this.props

    // Useful in development only
    if (!operatorUUID || !quoteUUID || !paymentMethod) {
      // return false // return false to _stay_ on processing page forever
      if (!operatorUUID) {
        operatorUUID = '984f763e-1fa0-4581-b088-7d2ea5ac13e3'
      }
      if (!quoteUUID) {
        quoteUUID = '778042d5-2e2d-410b-8dc5-3e1edd493535'
      }
      if (!paymentMethod) {
        paymentMethod = {
          type: 'credit_card',
          provider: 'verifone'
        }
      }
    }

    const params = {
      quote_id: quoteUUID,
      operator_id: operatorUUID,
      payment_method: paymentMethod
    }

    if (paymentMethod.type === 'sepa') {
      paymentMethod.provider_details = { name: 'slimpay', quote_id: quoteUUID }
      paymentMethod.provider_reference = 'required-by-billing'
    }

    // Well, well, well - time to clean up billing interface?
    if (paymentMethod.provider === 'verifone') {
      const searchParams = new URLSearchParams(window.location.search)

      paymentMethod.provider_reference = 'required-by-billing'
      paymentMethod.provider_details = {
        checkout_id: searchParams.get('checkout_id'),
        transaction_id: searchParams.get('transaction_id')
      }
      if (searchParams.has('error_code')) {
        this.setState({ status: 'error', response_code: searchParams.get('error_code') })
      }
    }

    if (paymentMethod.type === 'sepa' || paymentMethod.type === 'invoice') {
      if (typeof this.state.status === 'undefined') {
        this.makePayment(params)
      }
    }

    // For all: check payment status on regular interval
    this.interval = setInterval(() => {
      API.getQuote(params, (data) => {
        if (data.status === 'open') return

        /*
         * Implementation using top level App component for storage of
         * mypage token triggered re-render (with multiple calls
         * to componentDidMount on distinct components) causing
         * eg. makeSignupPayments to be called multiple times.
         *
         * To enable using local state to avoid multiple calls
         * (i.e. status), using sessionStorage for mypage
         * token is introduced. The token is picked up on the
         * welcome page and the session is cleared.
         *
         * Note: must happen _before_ setState is called as Welcome#render will pickup mypage-token.
         */
        if (data.mypageAccessKey) {
          sessionStorage.setItem('mypage-token', data.mypageAccessKey)
        }

        // Once payment is made, getQuote should also return a list of any documents to be signed
        // Store these to be used in the Welcome page
        if (data.documents) {
          sessionStorage.setItem('documents', JSON.stringify(data.documents))
        }

        // The member is sent back to the form, so a retry of the same quote
        // (e.g. signing the SEPA mandate again) must make the payment again
        if (data.status === 'payment_declined' || data.status === 'error') {
          sessionStorage.removeItem(this.paymentKey(params))
        }

        this.setState({
          status: data.status,
          declineReason: data.declineReason
        })
      }, (errorCode, errors) => {
        this.setState({ processing: false }, () => {
          if (errorCode === 422) {
            this.setState({ errors })
          } else {
            // TODO: Show error msg somewhere
            console.log(errorCode)
            console.log(errors)
          }
        })
      })
    }, 2000)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  render () {
    if (this.state.status === 'payment_accepted') {
      return <Redirect to='/welcome' />
    } else if (this.state.status === 'payment_declined') {
      const reason = this.state.declineReason ? `&reason=${encodeURIComponent(this.state.declineReason)}` : ''
      return <Redirect to={`/?status=declined${reason}`} />
    } else if (this.state.status === 'error') {
      return <Redirect to='/?status=error' />
    } else {
      return (
        <div className='content processing'>
          <section className='main'>
            <ActivityIndicator i18nKey='signup.payment_processing.title' />
          </section>
        </div>
      )
    }
  }
}

export default translate()(ProcessingPayment)
